import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession, signInWithRedirect } from 'aws-amplify/auth';
import React, { useMemo } from 'react';
import { useEffect } from 'react';
import { AuthProvider } from 'react-oidc-context';
import { Outlet } from 'react-router-dom';

import { useSessionStore } from 'session/useSessionStore';
import { CognitoRouteWrapper } from './CognitoRouteWrapper';
import { LoginLoader } from './LoginLoader';

export const CognitoSecureRoute = () => {
    const setJwt = useSessionStore((state) => state.setJwtToken);
    const tenantConfig = useSessionStore((state) => state.tenantConfiguration);

    const oidcConfig = useMemo(
        () =>
            tenantConfig?.cognitoAuthConfig && {
                authority:
                'https://cognito-idp.us-east-1.amazonaws.com/' +
                tenantConfig.cognitoAuthConfig.userPoolId,
                client_id: tenantConfig.cognitoAuthConfig.userPoolClientId,
                automaticSilentRenew: true,
                accessTokenExpiringNotificationTimeInSeconds: 120,
                redirect_uri:
                window.location.protocol +
                '//' +
                window.location.host +
                '/CallbackOIDC',
                scope: 'email openid',
                response_type: 'code',
                post_logout_redirect_uri:
              window.location.protocol + '//' + window.location.host + '/SignOut/',
            },
        [tenantConfig]);

    return !!tenantConfig && !!oidcConfig ? (
        <AuthProvider {...oidcConfig}>
            <CognitoRouteWrapper />
        </AuthProvider>
    ) : (
        <LoginLoader withCallback={false} />
    );
};
